const ErrorId = {
  //------------------------ System ---------------------
  SUCCESS: 'S0000',
  System__NoLogin: 'S0001',
  System__NoMethod: 'S0002',
  System__ErrorPath: 'S0003',
  System__ErrorFormate: 'S0004',
  System__ErrorParameter: 'S0005',
  System__PermissionNotAllow: 'S0006',
  System__UploadFileError: 'S0007',
  //------------------------ System ---------------------
  Login__AccountPasswordError: 'S0010',
  Login__TokenExpire: 'S0011',
  Login__TokenReflashFail: 'S0012',
  Login__AccountDisabled: 'S0013',
  Login__AccountNotActive: 'S0015',
  Login__GroupPermissionNotAllow: 'S0016',
  Login__AclPermissionNotAllow: 'S0017',
  //------------------------   Create Account ---------------------
  CreateAccount__AccountExist: 'S0020',
  //------------------------    Account ---------------------
  Account__PermissionNotAllow: 'S0040',
  Account__NotFound: 'S0041',
  Account__SendVerifiCodeFrequent: 'S0043',

  //------------------------   Group ---------------------
  Group__PermissionNotAllow: 'S0050',
  Group__NotFound: 'S0051',

  //------------------------   Device ---------------------
  Device__NoDevice: 'S0101',
  Device__PermissionNotAllow: 'S0102',
  Device__SendCommandFail: 'S0103',
  Device__NoIrControl: 'S0104',
  Device__NoIrControlKey: 'S0105',
  Device__UpdateDataFail: 'S0199',
  Device__DeviceExist: 'S0106',
  Device__NoUserId: 'S0107',
  Device__GwNotFound: 'S0108',
  Device__ActiveCodeError: 'S0109',
  Device__TooManySubDvice: 'S0110',
  Device__NoDeviceModel: 'S0111',
  Device__CommandCached: 'S0112',

  //------------------------   Trigger Action ---------------------
  TriggerAction__NoTrigger: 'S0501',
  TriggerAction__AddFaild: 'S0502',
  TriggerAction__UpdateFaild: 'S0503',
  TriggerAction__PermissionNotAllow: 'S0504',
  TriggerAction__DeleleFaild: 'S0505',

  //------------------------   Script Service ---------------------
  Script__NoScript: 'S0801',
  Script__PermissionNotAllow: 'S0802',
  Script__TooManyRequest: 'S0803',

  //------------------------   Other ---------------------
  Other__SystemError: 'S9999',
  Other__PathError: 'S9998',
  Other__500Error: 'S9997',
  Other__ErrorConfirmCode: 'S9996',
  JWTToken_Invalid: 'S2000',
  Input_Data_Error: 'S2010',
  Null_Pointer_Exception: 'S2011',
  Device_Exception: 'S2012',
  Invalid_Time_Range: 'S2013',
  Invalid_YearMonth_Format: 'S2014',

  //------------------------   Community ---------------------
  CommunityId_NotFound: 'S2100',
  CommunityNoticeId_NotFound: 'S2101',
  CommunityId_Or_BuildingId_Or_FloorId_NotFound: 'S2102',
  CommunityNoticeId_Update_Failed: 'S2103',
  CommunityNoticeId_Delete_Failed: 'S2104',
  CommunityNoticeId_Add_Failed: 'S2105',
  CommunityNoticeId_Cancel_Failed: 'S2106',
  SipCommunityId_Update_Failed: 'S2107',
  SipCommunityId_Duplicate_Entry: 'S2108',
  COMMUNITY_ALREADY_DOWNLOADED: 'S2109',

  //------------------------   Floor ---------------------
  Floor_Already_Exist: 'S2120',
  FloorId_NotFound: 'S2121',
  FloorPlan_Update_Fail: 'S2122',
  Building_Not_Found: 'S2123',

  //------------------------   SIP ---------------------
  SIP_Number_Exhausted: 'S2130',
  SIP_Register_Failed: 'S2131',
  SIP_UnRegister_Failed: 'S2132',
  Binding_count_is_over: 'S2133',
  UnRegister_Failed: 'S2134',
  User_Cancel_Failed: 'S2135',
  First_SIP_NotFound_Or_No_User: 'S2136',
  PushToken_NotFound: 'S2137',

  //------------------------   Household ---------------------
  HouseholdId_NotFound: 'S2140',
  Invalid_HouseholdCode: 'S2141',
  Mac_NotFound: 'S2142',
  Household_Create_Failed: 'S2143',
  Household_Update_Failed: 'S2144',
  Mac_Duplicate_Entry: 'S2180',
  HouseholdName_In_Community_Duplicate: 'S2181',

  //------------------------   MailPackage ---------------------
  MailPackageId_NotFound: 'S2150',
  MailPackage_Pickup_Failed: 'S2151',
  MailPackage_Return_Failed: 'S2152',
  MailPackage_Create_Barcode_Failed: 'S2153',
  Invalid_Compression_Input: 'S2154',

  //------------------------   Schedule ---------------------
  Add_Schedule_Fail: 'S2170',

  //------------------------   Registration ---------------------
  Duplicate_Registration: 'S2190',
  Registration_NotFound: 'S2191',

  //------------------------   Gasregistration ---------------------
  Gas_Registration_YearMonth_Already_Exist: 'S2200',
  Gas_Household_Registration_Already_Exist: 'S2201',
  Gas_Registration_Delete_Fail: 'S2202',
  Gas_RegistrationId_NotFound: 'S2203',
  Gas_Registration_Update_Fail: 'S2204',
  Gas_Registration_Past_YearMonth_Error: 'S2205',
  Gas_Registration_StartTime_Before_Previous_EndTime: 'S2206',
  Gas_Household_Registration_No_Change_After_DeadLine: 'S2207',
  Gas_Registration_Unable_To_Update_After_DeadLine: 'S2208',
  Gas_Registration_Not_Allowed_In_The_Same_Month: 'S2209',
  Pending_Gas_Registration_Filling_Not_Permitted: 'S2211',
  Gas_Filling_Not_Allowed_Before_Start_Date: 'S2212',
  Gas_Registration_Add_Failed: 'S2213',
  Gas_Registration_Invalid_Status: 'S2214',

  //------------------------   CSV ---------------------
  ERROR_EXPORTING_CSV: 'S2210',

  //------------------------   other new ---------------------
  TonnetDoorControl_Device_NotFound: 'S2220',
  Device_ANPR_NotFound: 'S2221',
  Device_MainDoor_AND_Security_Guard_Machine_NotFound: 'S2222',
  Device_VehicleGate_NotFound: 'S2223',
  Device_VehicleGate_Asid_Or_Key_Error: 'S2224',
  Device_VehicleGate_CarAddError: 'S2225',
  Device_VehicleGate_CarDelError: 'S2226',
  BuildingId_NotFound: 'S2230',
  Advertisement_NotFound: 'S2240',
  Advertisement_Update_Failed: 'S2241',
  Advertisement_Deactivate_Failed: 'S2242',
  Advertisement_Add_Failed: 'S2243',
  Account_NotFound: 'S2250',
  V3_Account_NotFound: 'S2251',

  //------------------------ Vehicle ---------------------
  Vehicle_Duplicate_Entry: 'S2260',
  Vehicle_Registration_Failed: 'S2261',
  Vehicle_Delete_Failed: 'S2262',
  Vehicle_NotFound: 'S2263',

  //------------------------ Login ---------------------
  Unauthorized_Login_SS: 'S2270',
  Unauthorized_Login_Community_WEB: 'S2271',
  Unauthorized_Login_Community_APP: 'S2272',

  //--------------- CFS ------------------
  Cfs_File_Not_Exist: 1002,

  //------------------------ QRCode ---------------------
  QrcodeExpire_NotFound: 'S2300',
  QrcodeExpire_Fetch_Fail: 'S2301',
  QrcodeExpire_Update_Fail: 'S2302',
}

export default ErrorId
